var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-h3"},[_vm._v("Sitio en construcción")])}
var staticRenderFns = []

export { render, staticRenderFns }